import { SortDirection } from "@redotech/cockroachdb-codegen/congodb/sort-direction";
import { WithdrawalStatus } from "@redotech/cockroachdb-codegen/tables/returns/withdrawal-status";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const withdrawalStatusSchema = z.nativeEnum(WithdrawalStatus);

/**
 * Which set of withdrawals (none of which have a linked return) a view shows.
 * - all: every status
 * - needs_action: requires_merchant_action only
 * - cancelations: every status except requires_merchant_action (legacy)
 */
export enum WithdrawalListView {
  ALL = "all",
  CANCELATIONS = "cancelations",
  NEEDS_ACTION = "needs_action",
}

const withdrawalListItemSchema_ = z.object({
  id: z.string(),
  orderId: z.string(),
  orderName: z.string().nullable(),
  customerName: z.string().nullable(),
  status: withdrawalStatusSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
  completedAt: z.date().nullable(),
  orderCancelledAt: z.date().nullable(),
  returnId: z.string().nullish(),
});
export const withdrawalListItemSchema: z.ZodType<WithdrawalListItem> =
  withdrawalListItemSchema_;
export interface WithdrawalListItem extends z.infer<
  typeof withdrawalListItemSchema_
> {}

const listWithdrawalsInput_ = z.object({
  view: z.nativeEnum(WithdrawalListView),
  pageSize: z.number().optional().default(25),
  offset: z.number().optional().default(0),
  sortDirection: z
    .nativeEnum(SortDirection)
    .optional()
    .default(SortDirection.Desc),
  search: z.string().max(200).optional(),
  advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
});
export const listWithdrawalsInput: z.ZodType<ListWithdrawalsInput> =
  listWithdrawalsInput_;
export interface ListWithdrawalsInput extends z.infer<
  typeof listWithdrawalsInput_
> {}

const listWithdrawalsOutput_ = z.object({
  withdrawals: z.array(withdrawalListItemSchema),
  total: z.number(),
  nextOffset: z.number().nullish(),
});
export const listWithdrawalsOutput: z.ZodType<ListWithdrawalsOutput> =
  listWithdrawalsOutput_;
export interface ListWithdrawalsOutput extends z.infer<
  typeof listWithdrawalsOutput_
> {}

export const listWithdrawals = {
  name: "listWithdrawals" as const,
  input: listWithdrawalsInput,
  output: listWithdrawalsOutput,
};
